import React from 'react'
import { Link } from 'react-router-dom'
import { getImages } from '../../Common/const';

const InventoryMdBox = ({ item, index, numberFormatter, priceFormatter }) => {

    const optionssl = {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true
    };
    return (
        <>
            <div className='col-lg-12 col-md-12 col-12' key={index}>
                <div className='pro-box pro-full-width'>
                    <div className='before-hover d-md-flex align-items-center p-0'>
                            <div className='lg-title text-uppercase mt-3 mb-4 text-theme d-md-none ps-5'><img src={getImages('arrow.svg')} /> Latest Drop</div>
                        <div className='pro-top order-2 text-md-end'>
                            {item.vdp_hero_image ?
                                <Link to={"/vehicle-details/" + item.vdp_url}><img src={item.vdp_hero_image}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = getImages(`car-isolated.png`);
                                    }}
                                    alt='srp' />
                                </Link> :
                                <img src={getImages('car-isolated.png')}
                                    alt='srp' />

                            }
                        </div>
                        <div className='pro-bottom p-md-4 p-4'>
                            <div className='lg-title text-uppercase mb-md-4 mb-3 text-theme d-none d-md-block'><img src={getImages('arrow.svg')} /> Latest Drop</div>
                            <div className='ps-md-4'>
                                <div className="md-title mb-2">{item.vehicle_name}</div>
                                <div className="sm-title mb-2">{item.transmission}</div>
                                <div className="xs-title mb-md-4 mb-2">{priceFormatter(item.mileage)} mi</div>
                                <div className="md-title pfw-price mb-md-4 mb-2">{priceFormatter(item.price, true)}</div>
                                <Link to={"/vehicle-details/" + item.vdp_url} className="vehicle-dtl-btn text-uppercase w-270 text-center" >Vehicle Details</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default InventoryMdBox